import React from "react";
import { Box, Typography, Link, IconButton } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import YouTubeIcon from "@mui/icons-material/YouTube";
import AccordionFooter from "./acordeonMobile/acordeon";
import { useAIWidget } from "../../context/AIWidgetContext.jsx";

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
  </svg>
);

const iconStyles = [
  {
    icon: <InstagramIcon />,
    backgroundColor: "#B51AD8",
    link: "https://www.instagram.com/hitpolyagencia/",
  },
  {
    icon: <LinkedInIcon />,
    backgroundColor: "#B51AD8",
    link: "https://pe.linkedin.com/company/hitpoly",
  },
  {
    icon: <WhatsAppIcon />,
    backgroundColor: "#B51AD8",
    link: "https://wa.me/51933961352",
  },
  {
    icon: <YouTubeIcon />,
    backgroundColor: "#B51AD8",
    link: "https://www.youtube.com/@hitpolyagenciademarketingd5365",
  },
  {
    icon: <TikTokIcon />,
    backgroundColor: "#B51AD8",
    link: "https://www.tiktok.com/@hitpolyoficial",
  },
];

const Footer = () => {
  const { openAssistant } = useAIWidget();
  return (
    <Box
      sx={{
        backgroundColor: "#f4f4f4",
        display: "flex",
        flexDirection: "column",
        padding: { xs: "40px 20px", sm: "40px 150px" },
        paddingBottom: { xs: "0px", sm: "0px" },
        paddingTop: { sm: "30px" },
        marginTop: { xs: "50px", sm: "0px" }
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alingItem: "center",
        }}
      >
        <Box
          sx={{
            width: {
              xs: "100%",
              sm: "30%",
              display: "flex",
              flexDirection: "column",
              marginTop: "10px",
            },
          }}
        >
          <img
            src="/images/logo-hitpoly.png"
            alt="Hitpoly Logo"
            style={{ width: "150px", height: "40px", marginBottom: "10px" }}
          />

          <Typography
            variant="body1"
            color="#211E26"
            sx={{
              lineHeight: "1.8",
              width: { xs: "100%", sm: "80%" },
              fontSize: { xs: "0.9rem", md: "0.8rem" },
            }}
          >
            En cada acción que emprendemos, buscamos transformar industrias,
            cambiar vidas y construir un mundo mejor. Lideramos la Revolución de
            Marketing y tecnología de Software con Propósito y Pasión.
          </Typography>
        </Box>

        <Box
          sx={{
            width: { xs: "100%", sm: "70%" },
            display: { xs: "none", sm: "flex" },
            marginTop: "10px",
          }}
        >
          <Box sx={{ width: "33%" }}>
            <Typography
              sx={{ fontSize: { xs: "0.9rem", md: "0.9rem" } }}
              variant="body1"
              color="#0B8DB5"
              gutterBottom
            >
              ENLACES RÁPIDOS
            </Typography>
            <Link
              href="/"
              color="#211E26"
              underline="none"
              display="block"
              sx={{
                marginBottom: "10px",
                fontSize: { xs: "0.9rem", md: "0.8rem" },
              }}
            >
              Home
            </Link>
            <Link
              href="/portfolio"
              color="#211E26"
              underline="none"
              display="block"
              sx={{
                marginBottom: "10px",
                fontSize: { xs: "0.9rem", md: "0.8rem" },
              }}
            >
              Portafolio
            </Link>
            <Link
              href="https://blog.hitpoly.com/"
              color="#211E26"
              underline="none"
              display="block"
              sx={{
                marginBottom: "10px",
                fontSize: { xs: "0.9rem", md: "0.8rem" },
              }}
            >
              Blog
            </Link>
            <Link
              href="/nosotros"
              color="#211E26"
              underline="none"
              display="block"
              sx={{
                marginBottom: "10px",
                fontSize: { xs: "0.9rem", md: "0.8rem" },
              }}
            >
              Nosotros
            </Link>
            <Link
              component="button"
              onClick={openAssistant}
              color="#211E26"
              underline="none"
              display="block"
              sx={{
                marginBottom: "10px",
                fontSize: { xs: "0.9rem", md: "0.8rem" },
                textAlign: 'left',
                border: 'none',
                backgroundColor: 'transparent',
                cursor: 'pointer',
                fontFamily: 'inherit',
                padding: 0
              }}
            >
              Contacto
            </Link>
          </Box>

          <Box sx={{ width: "33%" }}>
            <Typography
              sx={{ fontSize: { xs: "0.9rem", md: "0.9rem" } }}
              variant="body1"
              color="#0B8DB5"
              gutterBottom
            >
              POLITICAS
            </Typography>
            <Link
              href="/privacypolicy"
              color="#211E26"
              underline="none"
              display="block"
              sx={{
                marginBottom: "10px",
                fontSize: { xs: "0.9rem", md: "0.8rem" },
              }}
            >
              Politicas de privacidad
            </Link>
            <Link
              href="/disclaimer"
              color="#211E26"
              underline="none"
              display="block"
              sx={{
                marginBottom: "10px",
                fontSize: { xs: "0.9rem", md: "0.8rem" },
              }}
            >
              Descargo de responsabilidad
            </Link>
            <Link
              href="/termsandconditions"
              color="#211E26"
              underline="none"
              display="block"
              sx={{
                marginBottom: "10px",
                fontSize: { xs: "0.9rem", md: "0.8rem" },
              }}
            >
              Terminos y condiciones
            </Link>
            <Link
              href="/Copyright"
              color="#211E26"
              underline="none"
              display="block"
              sx={{
                marginBottom: "10px",
                fontSize: { xs: "0.9rem", md: "0.8rem" },
              }}
            >
              Copyright
            </Link>
          </Box>

          <Box sx={{ width: "34%" }}>
            <Typography
              sx={{ fontSize: { xs: "0.9rem", md: "0.9rem" } }}
              variant="body1"
              color="#0B8DB5"
              gutterBottom
            >
              CONTACTOS
            </Typography>
            <Link
              href="https://wa.me/51933961352" // Cambia esto a tu enlace de WhatsApp
              underline="none" // Elimina la decoración del enlace
              color="#211E26"
              sx={{
                marginBottom: "10px",
                fontSize: { xs: "0.9rem", md: "0.8rem" },
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  marginBottom: { xs: "10px", sm: "10px" },
                  fontSize: { xs: "0.9rem", md: "0.8rem" },
                  color: "#211E26"
                }}
              >
                +51933961352
              </Typography>
            </Link>
            <Link
              href="https://mail.google.com/mail/?view=cm&fs=1&to=info@hitpoly.com" // Enlace para abrir Gmail con un nuevo mensaje
              target="_blank" // Abre en una nueva pestaña
              underline="none" // Elimina la decoración del enlace
              color="#211E26"
            >
              <Typography
                variant="body1"
                sx={{
                  marginBottom: "10px",
                  fontSize: { xs: "0.9rem", md: "0.8rem" },
                  color: "#211E26"
                }}
              >
                info@hitpoly.com
              </Typography>
            </Link>
          </Box>
        </Box>
      </Box>

      <Box sx={{ display: { sm: "none", marginTop: "20px" } }}>
        <AccordionFooter />
      </Box>


      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          borderTop: "1px solid #1ECDF4",
          width: "100%",
          margin: "35px auto",
          justifyContent: "space-between",
          alignItems: "center",
          paddingTop: "30px",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: "#F21C63",
            fontSize: { xs: "0.9rem", md: "0.8rem" },
            textAlign: { xs: "center", md: "center" },
          }}
        >
          Copyright © 2024 hitpoly.com | Funciona con hitpoly.com
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: { xs: "30px", sm: "0px" },
            gap: { xs: 2, md: 2 },
          }}
        >
          {iconStyles.map(({ icon, backgroundColor, link }, index) => (
            <Link
              key={index}
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ display: "inline-block", lineHeight: 0 }}
            >
              <IconButton
                sx={{
                  backgroundColor: "#F21C63",
                  color: "#FFFFFF",
                  "&:hover": {
                    backgroundColor: "#bf0a46",
                    opacity: 0.8,
                  },
                  width: 36,
                  height: 36,
                  borderRadius: "8px",
                }}
              >
                {icon}
              </IconButton>
            </Link>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
